import { Reveal, Chapter } from "../components/Reveal";

export default function About() {
  return (
    <section
      id="about"
      data-testid="about-section"
      className="scroll-mt-24 border-t border-ink/10 py-24 md:py-32"
    >
      <div className="mx-auto max-w-3xl px-6">
        <Reveal>
          <Chapter number="11" label="About" />
        </Reveal>
        <Reveal delay={60}>
          <h2 className="font-display text-3xl font-medium leading-tight tracking-tight text-ink sm:text-4xl lg:text-5xl">
            About Leadtochair
          </h2>
        </Reveal>
        <Reveal delay={120}>
          <div className="mt-8 space-y-6 text-base leading-relaxed text-ink/70 md:text-lg">
            <p>
              Leadtochair is a focused, new service built specifically for private
              and cosmetic dental practices in the UK. It isn&apos;t a generic
              sales or marketing tool adapted for dentistry — it&apos;s designed
              from the start around how practices actually receive and handle
              enquiries: the phone, the website, WhatsApp and email.
            </p>
            <p>
              The service exists because the gap in many practices isn&apos;t
              generating interest — it&apos;s what happens in the hours and days
              after someone gets in touch. Leadtochair puts structure around that
              part: fast responses, consistent follow-up and clear visibility,
              handled in a way that supports your team rather than replacing it.
            </p>
            <p>
              We&apos;re early, deliberately. Working closely with a small
              number of founding practices means the system is shaped by real
              practice workflows, not assumptions. If that sounds like the right
              fit, we&apos;d be glad to talk.
            </p>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
